import { useMutation, useQueryClient } from '@tanstack/react-query'
import { reorderColumns, PeerAnalyserDisplayFilter } from '../repository/peer-analyser'
import { useToast } from '../state-management/contexts/ToastContext'
import type { FundsData } from '../types/peer-analyser'

export function useReorderColumns() {
  const { showToast } = useToast()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (filters: PeerAnalyserDisplayFilter[]) => reorderColumns({ filters }),
    onSuccess: (_data, filters) => {
      // Update query cache for all peerAnalyserFunds queries to ensure consistency across categories
      // This ensures that when switching categories, the updated filters are immediately available
      queryClient.setQueriesData<FundsData>({ queryKey: ['peerAnalyserFunds'] }, (oldData) => {
        if (oldData) {
          return {
            ...oldData,
            peerAnalyserDisplayFilters: filters
          }
        }
        return oldData
      })

      // Also persist globally so display settings/order are shared across all tabs
      // This serves as a fallback when API data is not yet updated
      try {
        localStorage.setItem('peerAnalyserDisplayFilters_global', JSON.stringify(filters))
      } catch {
        // Ignore storage errors (e.g., private mode)
      }
    },
    onError: (error) => {
      showToast({ message: 'Failed to save column preferences. Please try again.', width: '260px' })
      console.error('Failed to reorder columns:', error)
    }
  })
}
